import React from 'react'
import { Stack, Spinner } from 'react-bootstrap';


export default function AcademyLoading(props) {    
    return (
        <div style={{position:'absolute',top:'0',left:'0',height:'100vh',width:'100vw',backgroundImage:"url('https://imagedelivery.net/rHj-gKo2iv8uX7Gew5qNsg/f07e0c75-4728-4c29-bed7-19b7530fed00/w=3840')",backgroundPosition:'50% 60%',backgroundSize:'cover'}}>
        <Stack style={{display:'flex',justifyContent:'center',alignItems:'center',gap:'2rem',height:'100vh',padding:'0rem 2rem 2rem 2rem',backgroundColor:'rgba(0,0,0,0.5)'}} className="component component-text white text-shadow">
            <img src='https://imagedelivery.net/rHj-gKo2iv8uX7Gew5qNsg/98aaeb9d-d41f-4c68-ca59-ecd44c003200/max' style={{width:'100%',maxWidth:'400px',margin:'0 auto'}}/>
            <div style={{display:'flex',alignItems:'center',gap:'0.5rem',color:'white'}}>
                <Spinner animation="border" role="status"></Spinner>
                <span style={{fontSize:'1.2rem'}}>{props.type || 'Pagina'} aan het laden...</span>
            </div>

        </Stack>
    </div>
    );
}